import { Trans, useTranslation } from 'react-i18next';

import { useSidebarVersionContext } from '@spacefill/shared/src/utils/contexts/SidebarVersionContext';
import { useUserContext } from '@spacefill/shared/src/utils/contexts/UserContext';
import { DiscoveryPopover } from '@spacefill/uikit/src/components/DiscoveryPopover';

const STORAGE_KEY = 'sidebar-update-popover-v1-dismissed';

export const SidebarUpdatePopover = () => {
    const { t } = useTranslation();
    const { toggleSidebarVersion } = useSidebarVersionContext();
    const { user } = useUserContext();
    const isLsp = !!user?.logisticProviderId;

    return (
        <DiscoveryPopover
            storageKey={STORAGE_KEY}
            badgeLabel={t('New')}
            title={t('The navigation bar has changed!')}
            body={
                <>
                    <p className='mb-2 text-sm text-white/90'>
                        {t('We have reorganized the menu to help you find what you need faster.')}
                    </p>
                    <p className='mb-2 text-sm text-white/90'>
                        {isLsp ? (
                            <Trans
                                i18nKey='The sections are now grouped by theme — <0>outbound flows, incoming flows, collaboration, management</0> — for a more consistent experience.'
                                components={[
                                    <strong
                                        key='sections'
                                        className='font-semibold'
                                    />,
                                ]}
                            />
                        ) : (
                            <Trans
                                i18nKey='The sections are now grouped by theme — <0>sales, supply chain, collaboration, management</0> — for a more consistent experience.'
                                components={[
                                    <strong
                                        key='sections'
                                        className='font-semibold'
                                    />,
                                ]}
                            />
                        )}
                    </p>
                    <p className='text-sm text-white/90 mb-2'>
                        {t('Everything is still there, just better organized.')}
                    </p>
                </>
            }
            secondaryLabel={t('Switch back to the old navigation for now')}
            onSecondaryClick={toggleSidebarVersion}
            confirmLabel={t('Got it!')}
            baseline={
                <p className='text-sm text-white/90'>
                    {t('In two weeks’ time, the new navigation system will be fully implemented for everyone.')}
                </p>
            }
        />
    );
};
